import * as R from 'ramda'
import { of } from 'rxjs'
import { delayWhen, filter, switchMap } from 'rxjs/operators'
import { ofType } from 'redux-observable'
import { LOCATION_CHANGE, replace } from 'connected-react-router'
import { hasNoCypher } from 'domain/router'
import { toHref } from 'helpers/PathHelper'
import * as Actions from 'store/actions/index.ts'
import {
  getCountryCode,
  getCultureCode,
  getLoggedIn,
  getThemeName,
  getMarketId,
  getPartner,
  getQuery,
  getUri
} from 'store/selectors'

const removeCypherSSOEpic = (actions$, state$) =>
  actions$.pipe(
    ofType(LOCATION_CHANGE),
    delayWhen(() => (
      getLoggedIn(state$.value)
        ? of({})
        : actions$.pipe(ofType(Actions.member.MEMBER_INFO_FETCHED))
    )),
    filter(action => !hasNoCypher(action)),
    switchMap(() => {
      const state = state$.value
      const lc = `${getCultureCode(state)}-${getCountryCode(state)}`
      const market = getMarketId(state)
      const partner = getPartner(state)
      const query = getQuery(state)
      const theme = getThemeName(state)

      if (!__PRODUCTION__) {
        console.warn("Don't forget to refactor the query in removeCypherSSO epic")
      }

      const newQuery = R.compose(
        R.assoc('lc', lc),
        R.assoc('marketId', market),
        R.assoc('partner', partner),
        R.assoc('theme', theme),
        R.omit(['cypherSSO', 'distinct_id', 'mp_properties'])
      )(query)
      const pathname = getUri(state)

      const URLWithoutCypher = toHref({ pathname, query: newQuery }, query)

      return of(replace(URLWithoutCypher))
    })
  )

export default removeCypherSSOEpic
